import React from 'react'
import { Grid, Button } from 'semantic-ui-react'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import BarChart3D from './BarChart3D'
import Speedometer from './Speedometer'
import BrandGrid from './BrandGrid'
// import ChannelGroup from './ChannelGroup'
import PieChart from './PieChart'
import FilterDashboard from './FilterDashboard'
// import BrandPortfolio from './BrandPortfolio'
import StackedBar from './StackedBar'
// import AssetPortfolio from './AssetPortfolio'
import AssetGrid from './AssetGrid'
import DBData from './DBData'
// import comparisonCard from './ComparisonCard'
import ComparisonCard from './ComparisonCard'
import { updateTimings } from '../UserBehaviour/UserBehaviourTimer'
import ChannelGradientCards from './ChannelGradientCards'
import 'react-picky/dist/picky.css';
import { Dimple, BlueMoon } from '../BlueMoon'
import TopMedias from './TopMedias'
import axios from 'axios'
import DBDataV2 from './DBDatav2'
import { getTheme, getChannelToColorMap } from '../../config/clientConfig'
import { DEFAULT_EVENT_DATE_PARAM } from '../../config/defaults'

class Dashboard extends React.Component {
    constructor() {
        super();
        this.theme = getTheme();
        this.state = {
            href: document.location.href,
            dashBoardData: [], channel: [
                { key: 1, text: 'Social', value: 'Social' },
                { key: 2, text: 'Linear', value: 'Linear' },
                { key: 3, text: 'Highlights', value: 'Highlights' },
                { key: 4, text: 'Digital', value: 'Digital' }
            ], channelToColor: getChannelToColorMap(), channelToIcon: {
                "Linear": "fa fa-video-camera",
                "Social": "fa fa-rss",
                "Digital": "fa fa-tv",
                "Highlights": "fa fa-star"
            }, params: {
                "event_date": DEFAULT_EVENT_DATE_PARAM,
                "duration": "week"
            },
            filterDisplay: [], brands: [],
            totalDataCount: 0,
            filterGraphs: ['Bar', 'Line'],
            update: false,
            paramsToFetch: { duration: "week", "event_date": DEFAULT_EVENT_DATE_PARAM },
            importFile: undefined
        };
    }


    componentDidMount = () => {
        // console.log("component did mount of the dashboard is called");
        this.setState({ update: !this.state.update })
    }

    componentWillReceiveProps = () => {
        this.setState({ href: document.location.href })
        // console.log("comoponet will recieve of the dashboard is called");
    }
    increment_date = (current_date, days) => {
        var myDate = new Date(current_date);
        myDate.setDate(myDate.getDate() + days);
        var y = myDate.getFullYear(),
            m = myDate.getMonth() + 1, // january is month 0 in javascript
            d = myDate.getDate();
        var pad = function (val) { var str = val.toString(); return (str.length < 2) ? "0" + str : str };
        var dateString = [y, pad(m), pad(d)].join("-");
        return dateString;
    }

    setTimeLineData = () => {
        var timeLineData = []
        var counter = 365;
        var date = "1997-01-01"
        for (var i = 0; i < counter; i++) {
            date = this.increment_date(date, 1)
            timeLineData.push([date, Math.round(Math.random() * 100000)])

        }
        return timeLineData;
    }

    filterCharts = (selectedGraph) => {
        this.setState({ selectedGraph: selectedGraph });
    }

    fetchFilterData = () => {
        console.log("filtered data")
        this.setState({
            params: _.cloneDeep(this.state.paramsToFetch)
        })
    }

    selectFilter = (newParam, filter, shouldDelete, isDate) => {
        var paramsToFetch = this.state.paramsToFetch;
        console.log("newParam", newParam);

        if (shouldDelete === true) {
            delete paramsToFetch[newParam];
            this.setState({
                paramsToFetch: paramsToFetch
            });
        }
        else {

            if (_.isEqual(newParam, "reset"))
                this.setState({ params: {}, paramsToFetch: {}, dimmer: true, filterDisplay: [] });
            else {
                this.setState({ paramsToFetch: Object.assign(this.state.paramsToFetch, newParam), dimmer: true, filterDisplay: filter }, () => {
                    console.log("isDate", isDate)
                    if (isDate) {
                        this.fetchFilterData();
                    }
                });
            }

        }

    }



    handleChange = date => {
        this.setState({
            startDate: date
        });
    };






    componentDidUpdate = () => {
        var updateElements = document.getElementsByClassName("ui attached tabular menu")[0];
        if (!_.isUndefined(updateElements)) {
            updateElements.style.border = '1px';
            updateElements = updateElements.getElementsByTagName("a");

            for (var i = 0; i < updateElements.length; i++) {
                if (i == 0)
                    updateElements[i].style.backgroundColor = this.theme.accents.tab1;
                else if (i == 1)
                    updateElements[i].style.backgroundColor = this.theme.accents.tab2;
                else
                    updateElements[i].style.backgroundColor = this.theme.accents.tab3;

                updateElements[i].style.color = this.theme.text.onLight;
                updateElements[i].style.fontFamily = 'sans-serif';
                updateElements[i].style.fontWeight = 'bolder';
            }

        }
        var progress = document.getElementsByClassName("ui black tiny progress")
        for (var i = 0; i < progress.length; i++) {
            progress[i].style.margin = "0em"
            progress[i].style.marginTop = "0.2em"
            progress[i].style.backgroundColor = this.theme.progressBar.tiny

        }

    }



    displayComponents = () => {
        return (
            <Grid stackable style={{}}>
                <Grid.Row style={{ padding: 0 }}>
                    <Grid.Column width={12} stackable>

                        <Grid.Row >
                            <BrandGrid params={_.cloneDeep(this.state.params)} />
                        </Grid.Row>

                        <Grid.Row>
                            {(_.isEmpty(this.state.params.Brand) || this.state.params.Brand.split("<<!!>>").length === 1) ? <TopMedias brand={this.state.params.Brand} /> : null}
                        </Grid.Row>
                    </Grid.Column>


                    <Grid.Column width={4} textAlign={'left'}>

                        <AssetGrid params={_.cloneDeep(this.state.params)} />

                    </Grid.Column>
                </Grid.Row>


            </Grid>

        )
    }

    dashBoard = () => {
        return (
            <div style={{ paddingTop: '1rem', paddingRight: '1rem', boxSizing: "border-box", display: "flex", flexDirection: "column", flexGrow: "1" }}>



                <Grid stackable style={{ display: "flex", flexGrow: "1" }}>
                    <Grid.Row style={{ width: '100%' }}>
                        <div style={{ backgroundColor: '' }} />
                        <Grid.Column style={{ width: '74%' }}>
                            <StackedBar style={{}} channelToColor={this.state.channelToColor} params={_.cloneDeep(this.state.params)} />
                        </Grid.Column>
                        <Grid.Column width={4} style={{ padding: 0 }}>
                            <PieChart params={_.cloneDeep(this.state.params)} />
                        </Grid.Column>

                    </Grid.Row>
                </Grid>
                {this.displayComponents()}
                <Grid style={{ marginTop: `3rem` }}>
                    <Grid.Row >
                        <Grid.Column width={16}>
                            <ComparisonCard params={_.cloneDeep(this.state.params)} />
                        </Grid.Column>

                    </Grid.Row>
                </Grid>
                <div style={{ marginTop: 'auto', fontFamily: 'sans-serif', fontWeight: 'bolder', color: this.theme.text.secondary, display: "flex", justifyContent: "center", boxSizing: "border-box", padding: "0.5rem" }}

                >
                    Copyright © {new Date().getFullYear()} Wasserman Media.

                </div>
            </div>

        );
    }

    handleImportFileChange = (event) => {
        this.setState({ importFile: event.target.files[0] });
    }

    handleSheetUpload = (event) => {
        event.preventDefault();

        const url = `${BlueMoon.ip}importSheet`;
        const formData = new FormData();
        formData.append('file', this.state.importFile);
        formData.append('fileName', this.state.importFile.name);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        axios.post(url, formData, config).then((response) => {
            console.log(response.data);
        });
    }


    getComponent = () => {
        var exprs = this.state.href.split('/');
        var expr = exprs[exprs.length - 1]
        if (_.isEmpty(expr))
            return this.dashBoard();
        switch (expr) {
            case "3D-VIZ": return <BarChart3D params={_.cloneDeep(this.state.params)} channelToColor={this.state.channelToColor} />
            case "rawdata": return <DBDataV2 params={_.cloneDeep(this.state.params)} totalDataCount={this.state.dashBoardData.totalDataCount} />
            case "dashboard" || _.isEmpty(expr): return this.dashBoard();
        }
    }

    changeHref = (tab) => {
        updateTimings();
        this.props.history.push(`/dashboard/${tab}`)
    }



    tabView = () => {
        var isAdmin = localStorage.getItem("userRole") === "admin";
        return (
            <div style={{ paddingLeft: '4rem', paddingTop: '5rem', boxSizing: 'border-box', backgroundColor: this.theme.backgrounds.page, width: '100%', display: "flex", flexDirection: "column", minHeight: "0" }}>
                <ChannelGradientCards params={_.cloneDeep(this.state.params)} />
                <div style={{ padding: '1rem', display: "flex", gap: "12px", boxSizing: 'border-box', width: "calc(100vw - 7rem)" }}>
                    <Button size={'large'} content={'Dashboard'} style={{ boxSizing: 'border-box' }} color={this.theme.buttons.dashboard} onClick={this.changeHref.bind(this, 'dashboard')} />
                    <Button size={'large'} content={'3D-VIZ'} disabled={!isAdmin} color={this.theme.buttons.viz3d} onClick={this.changeHref.bind(this, '3D-VIZ')} />
                    <Button size={'large'} content={'Rawdata'} disabled={!isAdmin} color={this.theme.buttons.rawdata} onClick={this.changeHref.bind(this, 'rawdata')} />
                </div>
                {
                    <div style={{ backgroundColor: this.theme.backgrounds.page, display: 'flex', flexDirection: "column", boxSizing: "border-box", minHeight: "0", maxHeight: "100%", flexGrow: "1" }}>
                        <FilterDashboard selectFilter={this.selectFilter} displayFilter={this.state.filterDisplay} params={_.cloneDeep(this.state.paramsToFetch)} fetchFilterData={this.fetchFilterData} style={{ paddingRight: '0.1rem', boxSizing: 'border-box' }} />
                        {this.getComponent()}
                    </div>
                }
            </div>
        )
    }
    render() {
        if (_.isEmpty(localStorage.getItem('user'))) window.location.replace(`${Dimple}#/login`);
        console.log(`${Dimple}#/home`)
        if (_.isEmpty(localStorage.getItem('projectIp'))) window.location.replace(`${Dimple}#/home`);
        // console.log(React.version)
        if (_.isEmpty(localStorage.getItem('user'))) return null;
        return this.tabView();
    }
}


export default withRouter(Dashboard);

